import React from 'react'
const PersonInformationIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 7.5V9H14.25H16.5V7.5H12Z" fill="black" />
    <path d="M10.5 4.5V6H13.5H16.5V4.5H10.5Z" fill="black" />
    <path d="M13.5 10.5V12H15H16.5V10.5H13.5Z" fill="black" />
    <path
      d="M10.5 12.5625C10.5 11.0092 9.15685 9.75 7.5 9.75H4.5C2.84315 9.75 1.5 11.0092 1.5 12.5625V13.5H10.5V12.5625Z"
      stroke="black"
      strokeWidth="1.5"
    />
    <rect x="3.75" y="3" width="4.5" height="4.5" rx="2.25" stroke="black" strokeWidth="1.5" />
  </svg>
)
export default PersonInformationIcon
